import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DateTimeService } from './date-time.service';
import { observableToPromise } from '../functions/utility';

@Injectable({
  providedIn: 'root'
})
export class PipelineCountService {

  baseApiUrl: string = null;

  constructor(
    private http: HttpClient,
    private dateTimeService: DateTimeService
  ) {
    this.baseApiUrl = environment.openbridgeApiUris.pipelineCount;
  }

  async getAll(): Promise<any> {
    try {
      const getResponse = await observableToPromise(this.http.get(this.baseApiUrl + '/count', { observe: 'response' }));
      return getResponse;
    }
    catch (error) {
      throw error;
    }
  }

  async getByUTCDate(utcDateString: string, pageSize: number = 50): Promise<any> {
    try {
      const params: any = {
        date: utcDateString,
        page_size: pageSize
      };

      const httpParams: HttpParams = new HttpParams({ fromObject: params });

      const requestUrl =
        `${this.baseApiUrl}/count?${httpParams.toString()}`;

      const getResponse = await observableToPromise(
        this.http.get(requestUrl, { observe: 'response' })
      );

      return getResponse;
    } 
    catch (error) {
      throw error;
    }
  }

  transformResponse(value: any): any {
    const transformedData = {
      labels: value.date,
      data: value.count
    };

    return transformedData;
  }

  getDateRangeArray(s, e, format: string): any {
    for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
      a.push(this.dateTimeService.format(new Date(d), format));
    }
    return a;
  }

}
